/**
 * Developer mode: the diagnostics that regular users should never trip over.
 *
 * It is always on under `vite dev` (`import.meta.env.DEV`), so development
 * builds get everything for free. A release build keeps it off unless someone
 * opts in: `?dev=1` in the URL, or clicking the version line in Settings five
 * times. `?dev=0` turns it back off.
 */

import { prefs, savePrefs } from './prefs.svelte'

export const dev = {
  get on(): boolean {
    return import.meta.env.DEV || prefs.devMode
  },
}

export function setDevMode(value: boolean): void {
  prefs.devMode = value
  savePrefs()
}

/** Honour `?dev=1` / `?dev=0` once at startup. */
export function applyDevQuery(): void {
  if (typeof location === 'undefined') return
  const flag = new SvelteURLSearchParams(location.search).get('dev')
  if (flag === '1') setDevMode(true)
  else if (flag === '0') setDevMode(false)
}
import { SvelteURLSearchParams } from 'svelte/reactivity'
